import { render, staticRenderFns } from "./recentnews.vue?vue&type=template&id=12cab4ae&scoped=true&"
import script from "./recentnews.vue?vue&type=script&lang=js&"
export * from "./recentnews.vue?vue&type=script&lang=js&"
import style0 from "./recentnews.vue?vue&type=style&index=0&id=12cab4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cab4ae",
  null
  
)

export default component.exports